export { BroadcastChannelManager } from './BroadcastChannelManager';
export { broadcastRegistry, BroadcastManagerRegistry } from './BroadcastManagerRegistry';
export type { IBroadcastChannelManagerOptions } from './BroadcastChannelManager.types';
